import { gql } from '@apollo/client'

const BASE_STRATEGY_GROUP_FIELDS = gql`
  fragment BaseStrategyGroupFields on StrategyGroupType {
    id
    title
    description
    color
    order
    icon
    subject {
      id
    }
  }
`

const BASE_STRATEGY_FIELDS = gql`
  fragment BaseStrategyFields on StrategyType {
    id
    createdAt
    coverImage
    title
    description
    featuredArticleDescription
    content
    withWhiteImageBG
    tableOfContent {
      title
      slug
    }
    slug
    membershipLevel
    order
    getCoverImage
  }
`

export const FIND_ALL_STRATEGY_GROUP = gql`
  ${BASE_STRATEGY_GROUP_FIELDS}
  query findAllStrategyGroup($query: StrategyGroupQueryInput!) {
    findAllStrategyGroup(query: $query) {
      count
      items {
        ...BaseStrategyGroupFields
      }
    }
  }
`

export const CREATE_STRATEGY_GROUP = gql`
  ${BASE_STRATEGY_GROUP_FIELDS}
  mutation createStrategyGroup($createStrategyGroupInput: CreateStrategyGroupInput!) {
    createStrategyGroup(createStrategyGroupInput: $createStrategyGroupInput) {
      ...BaseStrategyGroupFields
    }
  }
`

export const REMOVE_STRATEGY_GROUP = gql`
  mutation removeStrategyGroup($removeStrategyGroupId: String!) {
    removeStrategyGroup(id: $removeStrategyGroupId) {
      raw
      affected
    }
  }
`
export const UPDATE_STRATEGY_GROUP = gql`
  mutation updateStrategyGroup($updateStrategyGroupInputFieldName: UpdateStrategyGroupInput!) {
    updateStrategyGroup(updateStrategyGroupInputFieldName: $updateStrategyGroupInputFieldName) {
      id
    }
  }
`
export const BULK_UPDATE_STRATEGY_GROUP = gql`
  mutation bulkUpdateStrategyGroup($bulkUpdateStrategyGroupInput: [BulkUpdateStrategyGroupInput!]!) {
    bulkUpdateStrategyGroup(bulkUpdateStrategyGroupInput: $bulkUpdateStrategyGroupInput) {
      id
    }
  }
`
export const BULK_REMOVE_STRATEGY_GROUP = gql`
  mutation bulkRemoveStrategyGroup($ids: [LinkStrategyGroupInput!]!) {
    bulkRemoveStrategyGroup(ids: $ids) {
      raw
      affected
    }
  }
`

export const FIND_ALL_STRATEGY = gql`
  ${BASE_STRATEGY_FIELDS}
  query findAllStrategy($query: StrategyQueryInput!) {
    findAllStrategy(query: $query) {
      count
      items {
        ...BaseStrategyFields
      }
    }
  }
`

export const CREATE_STRATEGY = gql`
  mutation createStrategy($createStrategyInput: CreateStrategyInput!) {
    createStrategy(createStrategyInput: $createStrategyInput) {
      id
    }
  }
`

export const UPDATE_STRATEGY = gql`
  ${BASE_STRATEGY_FIELDS}
  mutation updateStrategy($updateStrategyInputFieldName: UpdateStrategyInput!) {
    updateStrategy(updateStrategyInputFieldName: $updateStrategyInputFieldName) {
      ...BaseStrategyFields
    }
  }
`

export const FIND_ONE_STRATEGY = gql`
  ${BASE_STRATEGY_FIELDS}
  query findOneStrategy($id: String!) {
    findOneStrategy(id: $id) {
      ...BaseStrategyFields
      author {
        id
        getAvatar {
          photo
        }
        fullName
      }
      strategyGroup {
        id
        color
        title
      }
    }
  }
`

export const DELETE_STRATEGY = gql`
  mutation removeStrategy($removeStrategyId: String!) {
    removeStrategy(id: $removeStrategyId) {
      affected
      raw
    }
  }
`

export const BULK_REMOVE_STRATEGY = gql`
  mutation bulkRemoveStrategy($ids: [LinkStrategyInput!]!) {
    bulkRemoveStrategy(ids: $ids) {
      raw
      affected
    }
  }
`

export const BULK_UPDATE_STRATEGY = gql`
  mutation bulkUpdateStrategy($bulkUpdateStrategyInput: [BulkUpdateStrategyInput!]!) {
    bulkUpdateStrategy(bulkUpdateStrategyInput: $bulkUpdateStrategyInput) {
      id
    }
  }
`
